import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Card } from 'antd'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import './DoseCard.scss'

const renderDateReminders = (doseInfo) => {
  const { dateRemindersType, dateReminders } = doseInfo
  if (dateRemindersType === 'interval') {
    return `แจ้งเตือนทุกๆ ${dateReminders.length} วัน`
  } else if (dateRemindersType === 'weekdays') {
    const days = []
    const daysInWeek = ['จันทร์', 'อังคาร', 'พุธ', 'พฤหัส', 'ศุกร์', 'เสาร์', 'อาทิตย์']
    _.forEach(dateReminders, (o, i) => {
      if (o) days.push(daysInWeek[i])
    })
    return `แจ้งเตือนทุก${days.join(', ')}`
  } else if (dateRemindersType === 'birth') {
    let count = 0
    _.forEach(dateReminders, (o) => {
      if (o) count += 1
    })
    return `แจ้งเตือนการคุมกำเนิดแบบ ${count}+${28 - count}`
  }
  return ''
}

const renderTimeReminders = (doseInfo) => {
  const { timeReminders } = doseInfo
  const times = _.map(timeReminders, (timeObject) => {
    const timeString = moment(timeObject.time).format('HH:mm')
    return timeString
  })
  return `เวลา ${times.join(', ')}`
}

export const DoseCard = ({ doseInfo, loading }) => (
  <Card loading={loading} title={loading ? 'กำลังโหลด...' : doseInfo.name}>
    <p>{renderDateReminders(doseInfo)}</p>
    <p>{renderTimeReminders(doseInfo)}</p>
  </Card>
)

function mapStateToProps(state) {
  const {doseInfo, loading} = state;
  return {doseInfo, loading}
}

const getPatients = _.noop

function mapDispatchToProps(dispatch) {
  return {
    getPatients: bindActionCreators(getPatients, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)



// WEBPACK FOOTER //
// ./src/Card/DoseCard.js